import React, { Component } from 'react';
import './App.css';
import { Route, Switch, withRouter } from 'react-router-dom';
import NotFound from './Components/404';
import { ToastContainer, toast } from 'react-toastify';
import { connect } from 'react-redux';
import * as UIActions from './actions/ui';
import ReactLoading from 'react-loading';
import { injectIntl } from 'react-intl';
import Idle from 'react-idle';
import { AppConfig } from './configs';
import PublicTracking from "./Components/public-tracking/PublicTracking";
import RedirectPage from './Components/redirect/redirect'

class App extends Component {

    state = {
        idle: false,
        lastAction: Date.now(),
        selectedLocale: 'en',
    };

    componentDidUpdate(prevProps) {
        if (this.props.errorMessage && (!prevProps.errorMessage || prevProps.errorMessage !== this.props.errorMessage)) {
            toast.error(this.props.errorMessage, {
                onClose: () => this.props.clearErrMsg()
            })
        }

        if (this.props.successMessage && (!prevProps.successMessage || prevProps.successMessage !== this.props.successMessage)) {
            toast.success(this.props.successMessage, {
                onClose: () => this.props.clearSuccMsg()
            })
        }

    }

    componentDidMount() {
        this.setState({
            selectedLocale: this.props.locales.locale
        });
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            selectedLocale: nextProps.locales.locale
        })
    }

    navigateTo(to) {
        if (to && to !== this.props.location.pathname) this.props.history.push(to)
    }

    idleCallback = (idle) => {
        this.setState({
            idle
        });
    };

    render() {
        const { loading, location } = this.props;
        const { selectedLocale } = this.state;


        return (
            <div className="App appCont">
                <ToastContainer
                    position="top-center"
                    type="error"
                    autoClose={5000}
                    hideProgressBar={true}
                    newestOnTop={false}
                    closeOnClick
                    pauseOnHover
                    style={{
                        zIndex: 999999999999999
                    }}
                />

                <Idle
                    timeout={AppConfig.SESSION_TIMEOUT}
                    onChange={({ idle }) => this.idleCallback(idle)}
                />


                {loading && (
                    <div className="Loading-cont">
                        <ReactLoading
                            type="spinningBubbles"
                            color="#ffb639"
                        />
                    </div>
                )}

                <Switch>
                    <Route exact path="/" render={() => (<PublicTracking lang={selectedLocale} location={location} />)} />
                    <Route path="/public_tracking/:id" component={PublicTracking} />
                    <Route path="/public/:id/:token" component={PublicTracking} />
                     <Route path="/public/:id" component={PublicTracking} />
                    <Route path="/redirect/:status" component={RedirectPage} />
                    <Route component={NotFound} />
                </Switch>

            </div>
        );
    }
}

const mapStateToProps = ({ ui, locales }) => ({
    errorMessage: ui.errorMessage,
    successMessage: ui.successMessage,
    loading: ui.loading,
    locales
});

const mapDispatchToProps = (dispatch) => ({
    clearErrMsg: () => dispatch(UIActions.resetError()),
    clearSuccMsg: () => dispatch(UIActions.resetSuccess()),
});

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(App)));
